import { render, staticRenderFns } from "./generalTemplate.vue?vue&type=template&id=581c7134&scoped=true"
import script from "./generalTemplate.vue?vue&type=script&lang=js"
export * from "./generalTemplate.vue?vue&type=script&lang=js"
import style1 from "./generalTemplate.vue?vue&type=style&index=1&id=581c7134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c7134",
  null
  
)

export default component.exports